import { render, staticRenderFns } from "./CompanySubscription.vue?vue&type=template&id=6d0e5da8&"
import script from "./CompanySubscription.vue?vue&type=script&lang=ts&"
export * from "./CompanySubscription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports